<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">代理管理</Breadcrumb-item>
        <Breadcrumb-item>推荐记录</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="80" :show-message="false" label-position="right">
        <Row :gutter="32">
          <Col :span="6">
            <Form-item label="老生" >
                <Input name="inviteKey" placeholder="老生ID/手机号/昵称" v-model="queryParam.inviteKey"/>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="新生">
                <Input placeholder="新生ID/手机号/昵称" name="stdKey" v-model="queryParam.stdKey"/>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item :label-width="80" label="推荐人学导">
              <admin-user-select :status="1" adminGroupCode="userStudyAdviser" v-model="queryParam.studyAdviserId">
              </admin-user-select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="课程顾问" prop="studyAdviserName">
              <admin-user-select :status="1" adminGroupCode="adviser" v-model="queryParam.adviserId">
              </admin-user-select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item :label-width="80" label="是否已试听">
              <Select v-model.number="queryParam.isAudition" placeholder="全部" clearable @on-change="search">
                <Option v-for="item in $constant.yesNoNum" :value="item.code" :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="8">
            <Form-item label="创建时间">
              <Row>
                <Col :span="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                  @on-change="startTimeDateChange" style="width: 100%;"></Date-picker>
                </Col>
                <Col :span="1" style="text-align: center;">-</Col>
                <Col :span="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                  @on-change="endTimeDateChange" style="width: 100%;"></Date-picker>
                </Col>
              </Row>
            </Form-item>
          </Col>
          <Col :span="6">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                    @click="search" >搜索</Button>
          </Col>
        </Row>
        <Row justify="end" type="flex" class-name="export">
            <Button type="primary" :loading="exportLoading" :disable="exportLoading" icon="search"
                    @click="exportData">导出</Button>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/agentInvite/list"
      :params="queryParam" :onLoading="onLoading" operator=""></List>
  </div>

</template>
<script>
  export default {
    data () {
      let $moment = this.$moment
      let $constant = this.$constant
      return {
        searchLoading: false,
        exportLoading: false,
        reload: 0,
        tutorAll: [],
        queryParam: {
          inviteKey: '',
          stdKey: '',
          studyAdviserId: '',
          startCreateTime: null,
          endCreateTime: null,
          adviserId: '',
        },
        statusList: [{ code: 1, text: '已领奖' }, { code: 0, text: '未领奖' }],
        title: [
          {
            title: '昵称',
            // width: 200,
            render: (h, params) => {
              let row = params.row
              return h('span', row.userNickname)
            }
          },
          {
            title: '手机号',
            align: 'center',
            width: 150,
            key: 'mobile',
            render: (h, params) => {
              return h('Poptip', {
                props: {
                  trigger: 'hover'
                }
              }, [
                h('span', {}, params.row.mobile.length === 11 ? params.row.mobile.substring(0, 3)
                  + "****" + params.row.mobile.substring(7) : params.row.mobile),
                // 当前行展示的数据
                h('div', {slot: 'content'}, params.row.mobile)
              ])
            }
          },
          {
            title: '推荐人',
            width: 190,
            render: (h, params) => {
              let row = params.row
              return h('span', row.inviteId + ' - ' + (row.inviteNickname || ''))
            }
          },
          {
            title: '推荐人课程顾问',
            width: 150,
            render: (h, params) => {
              let row = params.row
              if (row.inviteAdviserName != null) {
                return h('span', row.inviteAdviserName)
              } else {
                return h('span', '')
              }
            }
          },
          {
            title: '推荐人学导',
            width: 150,
            render: (h, params) => {
              let row = params.row
              if (row.inviteStudyAdviserName != null) {
                return h('span', row.inviteStudyAdviserName)
              } else {
                return h('span', '')
              }
            }
          },
          {
            title: '创建时间',
            align: 'center',
            width: 170,
            render: (h, params) => {
              let createTime = params.row.createTime
              return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
            }
          },
          {
            title: '已试听',
            width: 80,
            align: 'center',
            render: (h, params) => {
              let isAudition = params.row.isAudition
              let audition = $constant.getEnum($constant.yesNoNum, isAudition)
              if (audition) {
                return h('span', audition.text)
              } else {
                return h('span', '')
              }
            }
          },
          {
            title: '成交时间',
            align: 'center',
            width: 170,
            render: (h, params) => {
              let payTime = params.row.payTime
              return h('span', payTime === 0 ? '' : $moment(payTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
            }
          },
          {
            title: '奖励',
            width: 120,
            key: 'prize'
          },
          {
            title: '状态',
            width: 150,
            align: 'center',
            key: 'status',
            render: (h, params) => {
              let status = params.row.status
              let statusEnum = $constant.getEnum(this.statusList, status)
              return h('span', statusEnum && statusEnum.text)
            }
          },
        ]
      }
    },
    mounted: function () {
    },
    created: function () {
      let self = this
      let params = { status: 1, adminGroupId: 4 }
      self.$http.get('/adminUser/listByCondition', { params: params }).then(function (res) {
        if (res && res.data) {
          self.tutorAll = res.data
        } else {
          self.tutorAll = []
        }
      })
    },
    methods: {
      search () {
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
      startTimeDateChange (value) {
        this.queryParam.startCreateTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      endTimeDateChange (value) {
        this.queryParam.endCreateTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      exportData () {
        this.exportLoading = true
        this.$http.get('/agentInvite/export', {responseType: 'arraybuffer', params: this.queryParam}).then((response) => {
          let blob = new Blob([response.data], {type: 'text/csv'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '推荐记录列表.xls'
          link.click()
          this.exportLoading = false
        }).catch((e) => {
          this.exportLoading = false
        })
      }
    }
  }

</script>


<style scoped>
  .export {
    margin-top: 24px;
  }
</style>



// WEBPACK FOOTER //
// AgentInviteList.vue?528d02fc